import {Injectable, OnDestroy} from '@angular/core';
import {
    AbstractFindManyPaginatedService
} from '../../../../../core/service/v2/service/findmany/abstractFindManyPaginated.service';
import {Scanner3dAccountModel} from '../../api/entity/scanner3dAccount.model';
import {Scanner3dAccountRepository} from './ngrx/scanner3dAccount.repository';
import {Scanner3dAccountDataServiceAdapter} from './ngrx/scanner3dAccountDataService.adapter';

@Injectable()
export class Scanner3dAccountPaginatedService extends AbstractFindManyPaginatedService<Scanner3dAccountModel, Scanner3dAccountModel>
    implements OnDestroy{

    constructor(repository: Scanner3dAccountRepository, dataServiceAdapter: Scanner3dAccountDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    resolveSortKeyLabel(value: string): string {
        switch (value) {
            case 'scanner.model.label': return 'Modèle de scanner';
        }
        return value;
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
